(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.codexjs = factory());
}(this, (function () { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var codexjs = createCommonjsModule(function (module, exports) {
	(function (global, factory) {
		module.exports = factory();
	}(commonjsGlobal, (function () {
		var commonjsGlobal$$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};

		function unwrapExports$$1 (x) {
			return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
		}

		function createCommonjsModule$$1(fn, module) {
			return module = { exports: {} }, fn(module, module.exports), module.exports;
		}

		var codexjs = createCommonjsModule$$1(function (module, exports) {
		(function (global, factory) {
			module.exports = factory();
		}(commonjsGlobal$$1, (function () {
			var commonjsGlobal$$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal$$1 !== 'undefined' ? commonjsGlobal$$1 : typeof self !== 'undefined' ? self : {};

			function unwrapExports$$1 (x) {
				return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
			}

			function createCommonjsModule$$1(fn, module) {
				return module = { exports: {} }, fn(module, module.exports), module.exports;
			}

			var codexjs = createCommonjsModule$$1(function (module, exports) {
			(function (global, factory) {
				module.exports = factory();
			}(commonjsGlobal$$1, (function () {
				var commonjsGlobal$$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal$$1 !== 'undefined' ? commonjsGlobal$$1 : typeof self !== 'undefined' ? self : {};

				function unwrapExports$$1 (x) {
					return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
				}

				function createCommonjsModule$$1(fn, module) {
					return module = { exports: {} }, fn(module, module.exports), module.exports;
				}

				var codexjs = createCommonjsModule$$1(function (module, exports) {
				(function (global, factory) {
					module.exports = factory();
				}(commonjsGlobal$$1, (function () {
					var commonjsGlobal$$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal$$1 !== 'undefined' ? commonjsGlobal$$1 : typeof self !== 'undefined' ? self : {};

					function unwrapExports$$1 (x) {
						return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
					}

					function createCommonjsModule$$1(fn, module) {
						return module = { exports: {} }, fn(module, module.exports), module.exports;
					}

					var codexjs = createCommonjsModule$$1(function (module, exports) {
					(function (global, factory) {
						module.exports = factory();
					}(commonjsGlobal$$1, (function () {
						var commonjsGlobal$$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal$$1 !== 'undefined' ? commonjsGlobal$$1 : typeof self !== 'undefined' ? self : {};

						function unwrapExports$$1 (x) {
							return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
						}

						function createCommonjsModule$$1(fn, module) {
							return module = { exports: {} }, fn(module, module.exports), module.exports;
						}

						var codexjs = createCommonjsModule$$1(function (module, exports) {
						(function (global, factory) {
							module.exports = factory();
						}(commonjsGlobal$$1, (function () {
							var commonjsGlobal$$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal$$1 !== 'undefined' ? commonjsGlobal$$1 : typeof self !== 'undefined' ? self : {};

							function unwrapExports$$1 (x) {
								return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
							}

							function createCommonjsModule$$1(fn, module) {
								return module = { exports: {} }, fn(module, module.exports), module.exports;
							}

							var codexjs = createCommonjsModule$$1(function (module, exports) {
							(function (global, factory) {
							    factory(exports);
							}(commonjsGlobal$$1, (function (exports) {
							    /*! *****************************************************************************
							    Copyright (c) Microsoft Corporation. All rights reserved.
							    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
							    this file except in compliance with the License. You may obtain a copy of the
							    License at http://www.apache.org/licenses/LICENSE-2.0

							    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
							    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
							    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
							    MERCHANTABLITY OR NON-INFRINGEMENT.

							    See the Apache Version 2.0 License for specific language governing permissions
							    and limitations under the License.
							    ***************************************************************************** */

							    function __awaiter(thisArg, _arguments, P, generator) {
							        return new (P || (P = Promise))(function (resolve, reject) {
							            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
							            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
							            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
							            step((generator = generator.apply(thisArg, _arguments || [])).next());
							        });
							    }

							    function __generator(thisArg, body) {
							        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
							        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
							        function verb(n) { return function (v) { return step([n, v]); }; }
							        function step(op) {
							            if (f) throw new TypeError("Generator is already executing.");
							            while (_) try {
							                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
							                if (y = 0, t) op = [op[0] & 2, t.value];
							                switch (op[0]) {
							                    case 0: case 1: t = op; break;
							                    case 4: _.label++; return { value: op[1], done: false };
							                    case 5: _.label++; y = op[1]; op = [0]; continue;
							                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
							                    default:
							                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
							                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
							                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
							                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
							                        if (t[2]) _.ops.pop();
							                        _.trys.pop(); continue;
							                }
							                op = body.call(thisArg, _);
							            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
							            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
							        }
							    }

							    var CONFIG = {
							        URL: 'https://api.openai.com/v1/engines/code-davinci-002/completions',
							        HEADERS: {
							            'Content-Type': 'application/json',
							            'authorization': 'Bearer sess-tkC6lWKaL7LsJXVb5kmIRehEW8yqncZFNrgLi7tj'
							        }
							    };

							    // 一个用于解析流数据的函数
							    function parseJson(data) {
							        var decoder = new TextDecoder();
							        return JSON.parse(decoder.decode(data).split('data: ')[1]);
							    }
							    // 用于发送请求，并处理的函数
							    function readStream(reader, doneFn) {
							        return __awaiter(this, void 0, void 0, function () {
							            var result, resultJson;
							            return __generator(this, function (_a) {
							                switch (_a.label) {
							                    case 0:
							                        return [4 /*yield*/, reader.read()];
							                    case 1:
							                        result = _a.sent();
							                        // 如果流中没有数据可读，则退出循环
							                        if (result.done) {
							                            return [3 /*break*/, 2];
							                        }
							                        resultJson = parseJson(result.value);
							                        doneFn(resultJson);
							                        return [3 /*break*/, 0];
							                    case 2: return [2 /*return*/];
							                }
							            });
							        });
							    }
							    // 处理options参数
							    function getOptions(inputStr) {
							        var bodyInfo = JSON.stringify({
							            "prompt": "<|endoftext|>/* I start with a blank HTML page, and incrementally modify it via <script> injection. Written for Chrome. */\n/* Command: Add \"Hello World\", by adding an HTML DOM node */\nvar helloWorld = document.createElement('div');\nhelloWorld.innerHTML = 'Hello World';\ndocument.body.appendChild(helloWorld);\n/* Command: Clear the page. */\nwhile (document.body.firstChild) {\n  document.body.removeChild(document.body.firstChild);\n}\n\n/* Command: " + inputStr + " */\nfunction unique(arr) {\n  return Array.from(new Set(arr));\n}\n\n/* Command: " + inputStr + " */\n",
							            "stream": true,
							            "max_tokens": 1000,
							            "temperature": 0,
							            "stop": "/* Command:"
							        });
							        return {
							            method: 'POST',
							            headers: CONFIG.HEADERS,
							            body: bodyInfo
							        };
							    }
							    // 发送请求接口
							    function sendRequest(options, doneFn, successFn, errorFn) {
							        fetch(CONFIG.URL, options)
							            .then(function (response) { return response.body; })
							            .then(function (body) {
							            var reader = body.getReader();
							            readStream(reader, doneFn).then(function () {
							                successFn && successFn();
							            }).catch(function (error) {
							                errorFn && errorFn(error);
							            });
							        });
							    }
							    /**
							     * 主入口
							     * @param inputStr 输入文案
							     * @param doneFn 阶段回调，API是分阶段 以数据流的方式，一次次传递过来
							     * @param successFn 数据流传递完成
							     * @param errorFn 数据流报错
							     */
							    function get(inputStr, doneFn, successFn, errorFn) {
							        var options = getOptions(inputStr);
							        sendRequest(options, doneFn, successFn, errorFn);
							    }
							    // if (typeof window === 'object') {
							    //   if ((window as any).codexjs === undefined) {
							    //       (window as any).codexjs = codexjs;
							    //   } else {
							    //       (console as any).warn(`codexjs属性被占用，请使用 _codexjs 初始化代码`)
							    //       (window as any)._codexjs = codexjs;
							    //   }
							    // }
							    var codexjs = {
							        get: get
							    };

							    const {
							        get: get$1
							    } = codexjs;

							    exports.default = codexjs;
							    exports.get = get$1;

							    Object.defineProperty(exports, '__esModule', { value: true });

							})));

							});

							var index = unwrapExports$$1(codexjs);

							return index;

						})));

						});

						var index = unwrapExports$$1(codexjs);

						return index;

					})));

					});

					var index = unwrapExports$$1(codexjs);

					return index;

				})));

				});

				var index = unwrapExports$$1(codexjs);

				return index;

			})));

			});

			var index = unwrapExports$$1(codexjs);

			return index;

		})));

		});

		var index = unwrapExports$$1(codexjs);

		return index;

	})));

	});

	var index = unwrapExports(codexjs);

	return index;

})));
//# sourceMappingURL=index.js.map
